<template>
  <v-layout>
    <v-flex>
      <div v-if="loading">
        <loading></loading>
      </div>
      <div v-if="showAlert == true">
        <alert-empty></alert-empty>
      </div>
      <v-widget
        class="px-0"
        :key="indexChart"
        v-if="dataReady == true"
        :title="tituloGraficaRegion"
        content-bg="white"
      >
        <div slot="widget-content">
          <e-chart
            :path-option="[
              ['dataset.source', res],
              [
                'color',
                [color.lightBlue.base, color.orange.base, color.grey.base],
              ],
              ['legend.show', true],
              ['xAxis.axisLabel.show', true],
              ['yAxis.axisLabel.show', true],
              ['grid.left', '2%'],
              ['grid.bottom', '5%'],
              ['grid.right', '3%'],
              //region 1
              ['series[0].type', 'bar'],
              ['series[0].areaStyle', {}],
              ['series[0].smooth', true],
              ['series[1].type', 'bar'],
              ['series[1].areaStyle', {}],
              ['series[1].smooth', true],
              ['series[2].type', 'bar'],
              ['series[2].areaStyle', {}],
              ['series[2].smooth', true],
            ]"
            height="400px"
            width="100%"
          ></e-chart>
        </div>
      </v-widget>
    </v-flex>
  </v-layout>
</template>

<script>
import API from "@/api";
import Util from "@/util";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import axios from "axios";
import { mapState } from "vuex";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  components: {
    VWidget,
    EChart,
    CircleStatistic,
    Loading,
    AlertEmpty,
  },
  mixins: [misMixins],
  props: {
    tipoPrueba: "",
    nivelFiltro: "",
    fechaFiltro: "",
  },
  data: () => ({
    showAlert: false,
    loading: false,
    color: Material,
    contratoId: "",
    selectedTab: "tab-1",
    pruebasRegion: [],
    menu1: false,
    dataReady: false,
    res: "",
    indexChart: 0,
    btnHidden: true,
    botonHidden: false,
    subProceso: "",
    tituloGraficaRegion: "",
  }),
  computed: {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.tituloGraficaRegion = "Evolución Progreso " + this.tipoPrueba;
    this.filter();
  },
  mounted() {},
  methods: {
    filter() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      //dibujar la grafica
      this.pruebasRegion = [];
      this.pruebasRegion = await this.loadFilter();
      if (this.pruebasRegion.length > 0) {
        this.showAlert = false;
        this.chartData();
      } else {
        this.showAlert = true;
      }
      this.dataReady = true;
      this.btnHidden = false;
      this.botonHidden = true;
      this.loading = false;
    },
    chartData() {
      let data = [];
      this.pruebasRegion.forEach((m) => {
        data.push({
          region: m.idRegion.nombre,
          Enviados: m.realizado,
          Recibidos: m.recibido,
          "Pte envio": m.total,
        });
        this.indexChart += 1;
      });
      this.res = data;
    },
    async loadFilter() {
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        // contratoId:this.contratoId,
        // idUserLogged: idUserLogged,
        subProceso: this.subProceso,
        idContrato: idContrato,
        nivel:
          this.nivelFiltro === undefined ? this.nivelFiltro : this.nivelFiltro,
        //tipoMaterial: this.tipoMaterialValue.description===undefined ? this.tipoMaterialValue : this.tipoMaterialValue.description ,
        tipoPrueba:
          this.tipoPrueba != "" && this.tipoPrueba != null
            ? this.tipoPrueba
            : null,
        //fecha_progreso: this.formatoFecha(this.fechaEvolucion)
        fecha_progreso: this.fechaFiltro,
      };
      return await axios
        .post("/evolucionFilterDistRegion", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
